/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Common,
  CreateSiteDtoTx,
  DeleteNoticeDtoTx,
  GetDetailSiteDtoRx,
  GetSiteDtoRx,
  SiteControllerCheckSiteParams,
  SiteControllerGetSitesParams,
  UpdateSiteDtoTx,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class SiteApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Site API
   * @name SiteControllerGetSites
   * @summary 사이트 조회
   * @request GET:/api/site
   * @secure
   */
  siteControllerGetSites = (query: SiteControllerGetSitesParams, params: RequestParams = {}) =>
    this.request<GetSiteDtoRx, any>({
      path: `/api/site`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Site API
   * @name SiteControllerCreateSite
   * @summary 사이트 등록
   * @request POST:/api/site
   * @secure
   */
  siteControllerCreateSite = (data: CreateSiteDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/site`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Site API
   * @name SiteControllerDeleteSite
   * @summary 사이트 삭제
   * @request DELETE:/api/site
   * @secure
   */
  siteControllerDeleteSite = (data: DeleteNoticeDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/site`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Site API
   * @name SiteControllerCheckSite
   * @summary 사이트 중복 조회
   * @request GET:/api/site/check
   * @secure
   */
  siteControllerCheckSite = (query: SiteControllerCheckSiteParams, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/site/check`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Site API
   * @name SiteControllerGetSite
   * @summary 사이트 상세 조회
   * @request GET:/api/site/{id}
   * @secure
   */
  siteControllerGetSite = (id: number, params: RequestParams = {}) =>
    this.request<GetDetailSiteDtoRx, any>({
      path: `/api/site/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Site API
   * @name SiteControllerUpdateStie
   * @summary 사이트 수정
   * @request PUT:/api/site/{id}
   * @secure
   */
  siteControllerUpdateStie = (id: number, data: UpdateSiteDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/site/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
